import {
  generateGetAction,
  // generatePutAction,
  generateDeleteAction,
  generateAction,
} from '@services/ActionDispatcher';

import {
  getMyDentistListAction,
  deleteAffiliatedDentistAction,
  getAffiliatedDentistReferralsAction,
  getUnreadAffiliatedReferralsCountAction,
  getPreferredDentistReferralAction,
  getUnreadPreferredDentistReferralsCountAction,

  updateMyNewDentistsCountAction,
  getClinicReferralFilterDentistListAction,
  getClinicReferralFilterListAction,
} from './ClinicActionConfig';

const updateMyNewDentistsCountDispatch = (
  data: any) => generateAction(updateMyNewDentistsCountAction, data);

const getAffiliatedDentistReferralsRequest = (params: any) => generateGetAction(
  // action name
  getAffiliatedDentistReferralsAction,
  // url
  `clinic/dentists/${params?.dentist_id}/affiliated/referrals`,
  {
    queryParams: params,
  },
  params,
);

const getMyDentistListRequest = (params: any) => generateGetAction(
  // action name
  getMyDentistListAction,
  // url
  'clinic/dentists/affiliated',
  {
    queryParams: params,
  },
  params,
);

const deleteAffiliatedDentistRequest = (data: any) => generateDeleteAction(
  // action name
  deleteAffiliatedDentistAction,
  // url
  `clinic/dentists/${data?.id}/affiliated`,
  data,
);

const getUnreadAffiliatedReferralsCountRequest = (params: any) => generateGetAction(
  // action name
  getUnreadAffiliatedReferralsCountAction,
  // url
  `clinic/dentists/${params?.dentist_id}/affiliated/referrals/unread`,
  {
    queryParams: params,
  },
  params,
);

const getPreferredDentistReferralRequest = (params: any) => generateGetAction(
  // action name
  getPreferredDentistReferralAction,
  // url
  `clinic/dentists/${params?.dentist_id}/preferred/referrals`,
  {
    queryParams: params,
  },
  params,
);

const getUnreadPreferredDentistReferralsCountRequest = (params: any) => generateGetAction(
  // action name
  getUnreadPreferredDentistReferralsCountAction,
  // url
  `clinic/dentists/${params?.dentist_id}/preferred/referrals/unread`,
  {
    queryParams: params,
  },
  params,
);

const getClinicReferralFilterDentistListRequest = (params: any) => generateGetAction(
  // action name
  getClinicReferralFilterDentistListAction,
  // url
  'clinic/referrals/dropdown/dentist',
  {
    queryParams: params,
  },
  params,
);

const getClinicReferralFilterListRequest = (params: any) => generateGetAction(
  // action name
  getClinicReferralFilterListAction,
  // url
  'clinic/referrals/dropdown/filter-list',
  {
    queryParams: params,
  },
  params,
);

export {
  // normal dispatch
  updateMyNewDentistsCountDispatch,

  // async (request) dispatch
  getMyDentistListRequest,
  deleteAffiliatedDentistRequest,
  getAffiliatedDentistReferralsRequest,
  getUnreadAffiliatedReferralsCountRequest,
  getPreferredDentistReferralRequest,
  getUnreadPreferredDentistReferralsCountRequest,
  getClinicReferralFilterDentistListRequest,
  getClinicReferralFilterListRequest,
};
